import { ExtensionSquareIcon } from '@dealstack/frontend/shared/components/DocumentCard/Components/SquareTextIcons';
import { TextV2 } from '@dealstack/frontend/shared/components/TextV2/TextV2';
import styled from 'styled-components';

export const ExtensionIconBox = styled.div`
	display: flex;
	height: 56px;
	padding: 12px;
	justify-content: center;
	align-items: center;
	gap: 8px;
	border-radius: 4px;
	border: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
	background-color: ${({ theme }) => theme.color.white[500]};

	${ExtensionSquareIcon} {
		width: 32px;
		height: 32px;
		border-radius: 4px;
		padding: 4px;
		background-color: ${({ theme }) => theme.v2.color.altLow.orange};

		${TextV2} {
			color: ${({ theme }) => theme.v2.color.alternateMid.orange};
			font-size: 10px;
			font-weight: 800;
			line-height: 12px;
		}
	}
`;

export const ProofFileBoxWrapper = styled.div`
	position: relative;

	/* Hide the default extension icon in the right side of DocumentCard */
	${ExtensionSquareIcon} {
		display: none;
	}

	/* Re-show it inside the left icon box */
	${ExtensionIconBox} ${ExtensionSquareIcon} {
		display: flex;
	}

	/* Vertically center DocumentCard header content */
	& > div:first-child > div:first-child {
		align-items: center;
	}
`;
